export const RECEIVE_LOCALE = 'RECEIVE_LOCALE';
export const REQUEST_LOCALE = 'REQUEST_LOCALE';
export const RECEIVE_SESSION = 'RECEIVE_SESSION';
export const REQUEST_SESSION = 'REQUEST_SESSION';
